var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnavailableSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-consumo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    transform: "translate(-1352.000000, -810.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-consumo",
    transform: "translate(1352.000000, 810.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Clip-5",
    points: "0 76 76 76 76 -1.13686838e-13 0 -1.13686838e-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.000001,76 C17.0139581,76 1.00000011e-06,58.9198699 1.00000011e-06,38 C1.00000011e-06,17.0139604 17.0139581,0 38.000001,0 C58.9198153,0 76.000001,17.0139604 76.000001,38 C76.000001,58.9198699 58.9198153,76 38.000001,76 Z M38.000001,3.04529864 C18.7352224,3.04529864 3.04529386,18.735258 3.04529386,38 C3.04529386,57.2648685 18.7352224,72.9546761 38.000001,72.9546761 C57.2647796,72.9546761 72.9547081,57.2648685 72.9547081,38 C72.9547081,18.735258 57.2647796,3.04529864 38.000001,3.04529864 Z",
    id: "Shape",
    fill: "#424242",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 38,
    cy: 38,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,6 L38,33.1895036 C40.6492901,33.1895036 42.8105117,35.3507296 42.8105117,38 L70,38 C70,20.291964 55.7079539,6 38,6 Z",
    id: "Path",
    fill: "#FF8300",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6299648,37.0738768 C42.6299648,38.0346991 42.4200244,38.8477677 42,39.5869596 L65.6599871,54 C68.3899304,48.9738344 70,43.2086183 70,37 L42.6299648,37 L42.6299648,37.0738768 Z",
    id: "Path",
    fill: "#FF8300",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#424242",
    fillRule: "nonzero",
    points: "40 6 37 6 37 10 40 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#424242",
    fillRule: "nonzero",
    transform: "translate(63.745481, 53.435879) rotate(-60.000000) translate(-63.745481, -53.435879) ",
    points: "65.2454812 51.4358791 62.2454812 51.4358791 62.2454812 55.4358791 65.2454812 55.4358791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,44 C34.6739159,44 32,41.3260213 32,37.9999377 C32,34.6738541 34.6739159,32 38,32 C41.3260841,32 44,34.6738541 44,37.9999377 C44,41.3260213 41.3260841,44 38,44 Z M38,34.9999065 C36.3695797,34.9999065 35,36.369551 35,37.9999377 C35,39.630449 36.3695797,40.9999688 38,40.9999688 C39.6304203,40.9999688 41,39.630449 41,37.9999377 C41,36.369551 39.6304203,34.9999065 38,34.9999065 Z",
    id: "Shape",
    fill: "#424242",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#424242",
    fillRule: "nonzero",
    points: "52.9395182 45.114064 43.6394506 39.3545176 42.2199021 41.9918162 51.5199696 47.7513626"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailableSchedule);
export default __webpack_public_path__ + "static/media/unavailableSchedule.7704c20efe651a945f44bfde67780bea.svg";
export { ForwardRef as ReactComponent };